import type { EreRecipientDto } from 'korint-sdk';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormTextInput } from '../../forms/form-text-input';
import { Stack } from '@folio/components/ui/flex';

type EreRecipientFieldsProps = Readonly<{
  control: Control<EreRecipientDto>;
}>;

/** Name/email/company fields for a letter recipient. */
export function EreRecipientFields({ control }: EreRecipientFieldsProps) {
  const { t } = useTranslation();

  return (
    <Stack>
      <FormTextInput
        control={control}
        name="firstName"
        label={t('notifications.recipientFields.firstName')}
        autoComplete="given-name"
        required
      />
      <FormTextInput
        control={control}
        name="lastName"
        label={t('notifications.recipientFields.lastName')}
        autoComplete="family-name"
        required
      />
      <FormTextInput
        control={control}
        name="email"
        type="email"
        label={t('notifications.recipientFields.email')}
        autoComplete="email"
        required
      />
      <FormTextInput
        control={control}
        name="company"
        label={t('notifications.recipientFields.company')}
        autoComplete="organization"
      />
    </Stack>
  );
}
